<template>
  <div>
    <div class="outdoor-pricelist-item-details" v-if="!isModalLoading">
      <div v-if="size" class="outdoor-pricelist-item-details__row">
        <div class="subhead">Size</div>
        <h1>{{ size }}</h1>
      </div>
      <div v-if="orientation" class="outdoor-pricelist-item-details__row">
        <div class="subhead">Orientation</div>
        <h1>{{ orientation }}</h1>
      </div>
      <div v-if="lighting" class="outdoor-pricelist-item-details__row">
        <div class="subhead">Lighting</div>
        <h1>{{ lighting }}</h1>
      </div>
      <div v-if="position" class="outdoor-pricelist-item-details__row">
        <div class="subhead">Position</div>
        <h1>{{ position }}</h1>
      </div>
      <div class="outdoor-pricelist-item-details__row">
        <div class="subhead">Total Slot</div>
        <h1>{{ totalSlot }}</h1>
      </div>
      <div class="outdoor-pricelist-item-details__row">
        <div class="subhead">Total Spot</div>
        <h1>{{ totalSpot }}</h1>
      </div>
      <div v-if="duration" class="outdoor-pricelist-item-details__row">
        <div class="subhead">Duration</div>
        <h1>{{ duration + 's' }}</h1>
      </div>
      <div v-if="resolution" class="outdoor-pricelist-item-details__row">
        <div class="subhead">Resolution</div>
        <h1>{{ resolution + ' px'}}</h1>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";

import { ALoadingPrimary } from "ui-kit-v1";

export default {
  name: "adx-outdoor-placement-tnc",
  components: {
    "a-loading": ALoadingPrimary
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      size: null,
      orientation: null,
      lighting: null,
      position: null,
      totalSlot: 0,
      totalSpot: 0,
      duration: null,
      resolution: null
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.outdoorPricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.size = `${data.location.width} x ${
          data.location.height
        } ${data.location.unit.toLowerCase()}`;
        this.orientation = data.location.orientation;
        this.lighting = data.location.lighting;
        this.position = data.location.position;
        this.totalSlot = data.location.total_slot;
        this.totalSpot = data.location.total_spot;
        this.duration = data.location.duration_per_slot;
        this.resolution = data.location.resolution;
      }

      this.isModalLoading = false;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>